export default __webpack_public_path__ + "static/media/meta.46aa5533.svg";